import t from"styled-components";const o=t.div`
	color: ${({theme:t})=>t.text.text};
	font-family: 'PP Formula';
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	cursor: pointer;
`;export{o as Label};
